import { CurrencyPipe, isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, AfterViewInit, Output, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { Router } from '@angular/router';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { IPackages, iTerms } from 'app/core/shared-services/interfaces.types';
import { ILead } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { environment } from 'environments/environment';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-confirm-cart',
  standalone: true,
  imports: [NgIf, NgxSkeletonLoaderModule, FormsModule, FuseAlertComponent, MatIconModule, 
    CurrencyPipe, NgFor, MatRadioModule, MatCheckboxModule],
  templateUrl: './confirm-cart.component.html',
  styleUrl: './confirm-cart.component.scss'
})
export class ConfirmCartComponent {

  @Input() dealerCode: string;
  @Input() currentPageTitle: string;
  @Input() lead: ILead;
  @Input() emailToken: string;
  @Input() leadRegistrationToken: string;
  @Input() passwordToken: string;
  @Input() userName: string;
  @Output() termsValue = new EventEmitter<any>();

  public loading: boolean = true;

  public corePackageResult: any;
  public corePackage: IPackages;
  public onceOffs: Array<IPackages> = [];
  public hasFibreInstalled: boolean = false;

  public providerLogo: string;

  public onceoffPrice: number = 0;
  public monthlyPrice: number = 0;

  public disableButton: boolean = true;

  private integrationUrl = environment.integrationUrl;

  private promoSalesItemsResult: any;
  public promoSalesItems: Array<IPackages>;
  public promoTypeArray: Array<any> = [];
  private promoAppliedResult: any;
  public promoApplied: any;
  public promoCode: string;
  public promoResult: any;

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;

  private channelPartnerOrderResult: any;
  private channelPartnerOrder: any;

  private verifyEmailResult: any;

  private referrer: string;
  private gtmCount: number = 0;

  public accountVerified: boolean;

  public reviewCartDealerEventCount: number = 0;

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private _authService: AuthService,
    private router: Router,
    private _gtmService: GtmService,
    private _webStorage: WebStorage,

    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  async ngOnChanges() {

    if(this.lead && this.emailToken) {
      this.channelPartnerOrderResult = await this._sharedMethods.getChannelPartnerOrder(this.lead.LeadEntityID);
  
      if(this.channelPartnerOrderResult.success) {
        this.channelPartnerOrder = this.channelPartnerOrderResult.result;
        if(this.channelPartnerOrder.IsCompleted) {
          this.router.navigateByUrl('/dashboard').then(()=>{
           location.reload();
          });
        }
      } else {
        this._authService.verifyEmailAddress(this.emailToken)
          .subscribe({
            next: async () => {
              this.alert = { type:'success', message: 'Account verified successfully' };
              this.showAlert = true;
              this.accountVerified = true;
              await this._sharedMethods.createChannelPartnerOrder(this.lead.LeadEntityID, this.emailToken, true, this.leadRegistrationToken, false, this.passwordToken, this.userName);
            },
            error: async(error) => {
              this.alert = { type: 'error', message: 'Error verifying account' };
              this.showAlert = true;
              this.loading = false;
              this.accountVerified = false;
            }
          })
      }

    }

    if (this.lead) {
      this.corePackageResult = await this._sharedMethods.getLinkedOfferablesByLeadId(this.lead.LeadEntityID);
      this.monthlyPrice = 0;
      this.onceoffPrice = 0;
      if (this.corePackageResult.success) {
        this.corePackageResult.result.forEach(async (element: IPackages) => {
          if (element.IsAddon) {
            this.onceOffs.push(element);
          } else {

            this.corePackage = element;
            this.providerLogo = this.integrationUrl + '/organisations/' + this.corePackage?.PackageSupplierOrganisationEntityID + '/logo';

            let packageToCart = {
              PackageEntityID: element?.PackageEntityID,
              LeadEntityID: this.lead.LeadEntityID,
              Price: element.RecurringTotal ?? element.Billing_TotalTempIncl
            };
      
            this._webStorage.CartInfo.next(packageToCart);
            localStorage.setItem('cartInfo', JSON.stringify(packageToCart));

            // if additional services to the coreProduct
            // calculate amount
            if (!element.Billing_IsRecurring) {
              this.calculateTotalPrice('add', false, element.Billing_TotalIncl);
            } else {
              this.calculateTotalPrice('add', true, element.Billing_TotalIncl);
            }
          }
        });

        // if (this.gtmCount < 1) {
        //   this.gtmCount++;
        //   this.gtmEvent();
        // }
        this.gtmEvent();

        
        this.loading = false;
      }
    }
  }

  public async redeemPromoCode(code: string) {

    this.promoResult = await this._sharedMethods.applyPromoCode(this.lead.LeadEntityID, code);
    this.promoSalesItemsResult = await this._sharedMethods.getPromoSalesItems(this.lead.LeadEntityID);

    if(this.promoSalesItemsResult.success) {
      this.promoCode = '';
      this.promoSalesItems = this.promoSalesItemsResult.result;
      
      this.promoSalesItems.forEach((element: IPackages) => {
        if (element.PromoCode) {
          // id discount is 100% or free
          // send the amount before discount to be deducted from total amount
          // else minus before amount from after amount and send that to be deducted from total
          const amount = element.Billing_TotalIncl =! 0 ? element.Billing_PriceIncl - element.Billing_TotalIncl : element.Billing_PriceIncl ;
          const promoType = {
            name: code,
            amount: element.Billing_DiscountAmount,
            type: element.Billing_DiscountTypeCode == 'Fixed' ? 'R' : '%'
          }
          this.promoTypeArray.push(promoType);
          this.calculateTotalPrice('remove', element.Billing_IsRecurring, amount);
        }
      });
    }

    if (this.promoResult.success) {
      this.alert = { type:'success', message: 'Promo code applied successfully' };
      this.showAlert = true;
      this.promoAppliedResult = await this._sharedMethods.getAppliedPromoCode(this.lead.LeadEntityID);
      this.promoApplied = this.promoAppliedResult.result;
    } else {
      this.alert = { type: 'error', message: this.promoResult.error };
      this.showAlert = true;
    }
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private calculateTotalPrice(type: string, recurring: boolean, amount: number) {

    if (!recurring) {
      if (type == 'add') {
        this.onceoffPrice += amount;
      } else {
        this.onceoffPrice -= amount;

      }
    } else if (type) {
      if (type == 'add') {
        this.monthlyPrice += amount;
      } else {
        this.monthlyPrice -= amount;
      }
    }
  }

  public gtmEvent() {
    if (isPlatformBrowser(this.platformId)) {

      if (this.currentPageTitle) {
        if(localStorage.getItem('currentURL')) {
          if(localStorage.getItem('currentURL') == window.location.href) {
          } else {
            this.referrer = localStorage.getItem('currentURL')
            localStorage.setItem('currentURL', window.location.href);
            localStorage.setItem('previousURL', this.referrer);
          }
        } else {
          localStorage.setItem('currentURL', window.location.href);
        }

        const corePackageData: any = this.corePackage;
    
        if (this.reviewCartDealerEventCount < 1) {
          this.reviewCartDealerEventCount++

          const route = window.location.href;
          const path = this.router.url;
          this._gtmService.pushEvent({ 
            event: 'review_cart_dealer',
            page_url: route,
            page_path: path,
            page_referrer: this.referrer ? this.referrer : route,
            page_title: `${this.currentPageTitle}`,
            dealer_code: this.dealerCode,
            package_price: corePackageData?.Billing_TotalIncl,
          });
        }

      } else {

        if(localStorage.getItem('currentURL')) {
          if(localStorage.getItem('currentURL') == window.location.href) {
          } else {
            this.referrer = localStorage.getItem('currentURL')
            localStorage.setItem('currentURL', window.location.href);
            localStorage.setItem('previousURL', this.referrer);
          }
        } else {
          localStorage.setItem('currentURL', window.location.href);
        }
    
        const route = window.location.href;
        const path = this.router.url;
        this._gtmService.pushEvent({ 
          event: 'review_cart_online',
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route,
          page_title: 'review_cart_online',
        });

      }



    }


  }

  public clearCart() {
    localStorage.removeItem('cartInfo');
    this._webStorage.CartInfo.next(0);
    this.router.navigate(['/']);
  }

    public addressHasFibre(event: any) : void {
    this.hasFibreInstalled = !event.value;
  }

}
